import { SprintState } from '@superthread-com/api';

export default function useGetSprintStatusByDates() {
  const sprintStatus = (sprint: any): string => {
    const { start_date, end_date } = sprint;
    const currentDate = new Date();
    const startDate = new Date(start_date * 1000);
    const endDate = new Date(end_date * 1000);

    if (currentDate >= startDate && currentDate <= endDate) {
      return SprintState.Active;
    } else if (currentDate < startDate) {
      return SprintState.Planned;
    } else {
      return SprintState.Completed;
    }
  };

  return {
    sprintStatus,
  };
}
